import request from "@/utils/request";

// 图片上传
export function uploadImage(data, progress) {
  return request({
    url: "/setting/oss/upload-image",
    method: "post",
    headers: {
      "Content-type": "multipart/form-data",
    },
    data,
    onUploadProgress: progress,
  });
}
export function accessLog(data) {
  return request({
    url: "/product/access-log",
    method: "post",

    data,
  });
}
export function getMessage() {
  return request({
    url: "/user/internal-message/findByCustomerId",
    method: "get",
  });
}